import { yupRequiredString } from "components/Forms/yupValidators";
import * as Yup from "yup";

export const HTTPExportConfigurationSchema = Yup.object().shape({
  host: Yup.string()
    .required("Must be a valid HTTPS URL")
    .matches(/^https:\/\/.*/i, "Must be a valid HTTPS URL")
    .url("Must be a valid HTTPS URL"),
  username: yupRequiredString,
  password: yupRequiredString,
  port: Yup.number()
    .min(0, "Must be a valid TCP port 0-65,535")
    .max(65535, "Must be a valid TCP port 0-65,535"),
  path: Yup.string().optional(),
  params: Yup.array()
    .of(
      Yup.object().shape({
        key: Yup.string().required(),
        value: Yup.string().required(),
      }),
    )
    .test("unique-keys", "Duplicate param keys are not allowed", (pairs) => {
      if (!pairs) return true;
      const keys = pairs.map((p) => p.key).filter(Boolean);
      return keys.length === new Set(keys).size;
    })
    .optional(),
});
